<template>
  <div
    :class="[
      { Button__blue: colour === 'blue' },
      { Button__orange: colour === 'orange' },
      { Button__white: colour === 'white' },
      { Button__darkGrey: colour === 'darkGrey' },
      { Button__close: isClose },
      { Button__noBorder: noBorder },
      { Button__roundedCorners: roundedCorners },
      { Button__backArrow: backArrow },
      $style.button,
    ]"
  >
    <a
      v-if="isLink"
      :aria-label="ariaLabel"
      :href="href"
      :target="targetBlank ? '_blank' : '_self'"
    >
      <span>{{ text }}</span>
    </a>
    <a
      v-else-if="isTabLink"
      :aria-label="ariaLabel"
      :href="href"
      @click="handleTabLinkClick(tabID)"
    >
      {{ text }}
    </a>
    <button v-else-if="isForm" :aria-label="ariaLabel" :type="type" @click.prevent="handleClick()">
      {{ text }}
    </button>
    <button
      v-else-if="!isLink && !isClose"
      :aria-label="ariaLabel"
      :disabled="isDisabled"
      :type="type"
      @click="handleSimpleClick"
    >
      {{ text }}
    </button>
    <button
      v-else-if="!isLink && isClose && !text"
      :aria-label="ariaLabel"
      :class="$style.closeX"
      :type="type"
      @click="handleClick"
      v-html="rawHtml"
    />
    <button
      v-else-if="!isLink && isClose && text"
      :aria-label="ariaLabel"
      :type="type"
      @click="handleClick"
    >
      {{ text }}
    </button>
  </div>
</template>

<script setup>
import CustomEvents from '../../globals/constants/customEvents';

const emit = defineEmits(['close', 'onSimpleClick']);

const props = defineProps({
  colour: {
    type: String,
    default: 'blue',
  },
  href: String,
  isClose: {
    type: Boolean,
    default: false,
  },
  isLink: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'button',
    validator: (value) => ['button', 'submit', 'reset'].indexOf(value) >= 0,
  },
  isForm: {
    type: Boolean,
    default: false,
  },
  noBorder: {
    type: Boolean,
    default: false,
  },
  isTabLink: {
    type: Boolean,
    default: false,
  },
  tabID: {
    type: String,
    default: '',
  },
  ariaLabel: {
    type: String,
    default: undefined,
  },
  roundedCorners: {
    type: Boolean,
    default: false,
  },
  targetBlank: {
    type: Boolean,
    default: false,
  },
  backArrow: {
    type: Boolean,
    default: false,
  },
});

const rawHtml = '&times;';

const handleClick = () => {
  window.dispatchEvent(
    new CustomEvent('button:close', {
      detail: { props },
    }),
  );

  emit('close');
};
const handleSimpleClick = () => {
  window.dispatchEvent(
    new CustomEvent('button:onSimpleClick', {
      detail: { props },
    }),
  );

  emit('onSimpleClick');
};

const handleTabLinkClick = (tabID) => {
  window.dispatchEvent(
    new CustomEvent(CustomEvents.OPEN_TAB_FROM_LINK, {
      detail: tabID,
    }),
  );
};
</script>

<style module lang="scss">
@forward './Button.scss';
</style>
